<div class="modal-header">
    <h5 class="modal-title">Import Salary Scales with Lines</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-0">
    <div *ngIf="insertionMessage" class="progress-message">
        <span *ngIf="isInserting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        {{ insertionMessage }}
    </div>

    <div *ngIf="formatError" class="alert alert-danger m-3">
        <p>Incorrect file format. Please download the template and fill it in accordingly.</p>
        <button class="download-button" (click)="downloadTemplate()">Download Template</button>
    </div>

    <div class="table-responsive" *ngIf="displayTable && !formatError">
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 w-100">

            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <input type="checkbox"
                        (change)="toggleSelectAll($event.target.checked)"
                        [checked]="selectedRows.length === importedData.length && importedData.length > 0">
                </th>
                <td mat-cell *matCellDef="let row">
                    <input type="checkbox"
                        (change)="onCheckboxChange(row, $event.target.checked)"
                        [checked]="isSelected(row)">
                </td>
            </ng-container>

            <ng-container matColumnDef="rowType">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Type</th>
                <td mat-cell *matCellDef="let row">
                    <span class="row-type-badge"
                        [class.badge-header]="row._rowType === 'header'"
                        [class.badge-header-line]="row._rowType === 'header+line'"
                        [class.badge-line]="row._rowType === 'line'">
                        {{ row._rowType === 'header' ? 'Scale Header' :
                           row._rowType === 'header+line' ? 'Header + Line 1' : 'Scale Line' }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-primary">Name</th>
                <td mat-cell *matCellDef="let row">{{ row.name }}</td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Description</th>
                <td mat-cell *matCellDef="let row">{{ row.description }}</td>
            </ng-container>

            <ng-container matColumnDef="isDailyRate">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Daily Rate?</th>
                <td mat-cell *matCellDef="let row">{{ row.isDailyRate }}</td>
            </ng-container>

            <ng-container matColumnDef="isMinimumWage">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Min. Wage?</th>
                <td mat-cell *matCellDef="let row">{{ row.isMinimumWage }}</td>
            </ng-container>

            <ng-container matColumnDef="isAllowance">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Allowance?</th>
                <td mat-cell *matCellDef="let row">{{ row.isAllowance }}</td>
            </ng-container>

            <ng-container matColumnDef="ratePerPeriod">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Rate/Period</th>
                <td mat-cell *matCellDef="let row">{{ row.ratePerPeriod }}</td>
            </ng-container>

            <ng-container matColumnDef="monthlyRate">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Monthly Rate</th>
                <td mat-cell *matCellDef="let row">{{ row.monthlyRate }}</td>
            </ng-container>

            <ng-container matColumnDef="dailyRate">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Daily Rate</th>
                <td mat-cell *matCellDef="let row">{{ row.dailyRate }}</td>
            </ng-container>

            <ng-container matColumnDef="hourlyRate">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Hourly Rate</th>
                <td mat-cell *matCellDef="let row">{{ row.hourlyRate }}</td>
            </ng-container>

            <ng-container matColumnDef="minuteRate">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Minute Rate</th>
                <td mat-cell *matCellDef="let row">{{ row.minuteRate }}</td>
            </ng-container>

            <ng-container matColumnDef="hoursPerDay">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Hours/Day</th>
                <td mat-cell *matCellDef="let row">{{ row.hoursPerDay }}</td>
            </ng-container>

            <ng-container matColumnDef="minValue">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Min Value</th>
                <td mat-cell *matCellDef="let row">{{ row.minValue }}</td>
            </ng-container>

            <ng-container matColumnDef="maxValue">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Max Value</th>
                <td mat-cell *matCellDef="let row">{{ row.maxValue }}</td>
            </ng-container>

            <ng-container matColumnDef="validFrom">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Valid From</th>
                <td mat-cell *matCellDef="let row">{{ row.validFrom }}</td>
            </ng-container>

            <ng-container matColumnDef="validTo">
                <th mat-header-cell *matHeaderCellDef class="text-primary">Valid To</th>
                <td mat-cell *matCellDef="let row">{{ row.validTo }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                [class.row-is-header]="row._rowType === 'header' || row._rowType === 'header+line'"
                [class.row-is-line]="row._rowType === 'line'"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
    </div>
</div>

<div class="modal-footer large-modal" *ngIf="!isImported">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
    <button *ngIf="!isLoading; else loadingTemplate"
        [disabled]="formatError || selectedRows.length === 0"
        type="button" class="btn btn-primary" (click)="save()">
        Import
    </button>
    <ng-template #loadingTemplate>
        <button type="button" class="btn btn-primary" disabled>
            Importing <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
    </ng-template>
</div>

<div class="modal-footer large-modal" *ngIf="isImported">
    <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
</div>
